import { assert } from 'superstruct';
import { SwipeGamesItemSchema, SwipeGamesItem } from '../shares/model/swipe';
import logger from '../shares/lib/logger';
import removeSwipeSdk from '../features/removeSwipeSdk';
import { setLocalStore } from '../shares/lib/localStore';
import { LocalStoreKeys } from '../shares/enums/localStoreKeys';
import { LogiSDKConfig } from '../shares/model/config';
import {
  fetchGameListV1,
  fetchGameListV2,
} from '../shares/helpers/gameListHelpers';
import { isTenantFeatureEnabled } from '../shares/helpers/tenantFeatureHelper';
import { TenantFeature } from '../shares/enums/tenantFeatures';

const handleError = (error: Error | unknown) => {
  logger.error('Error during data fetching/formatting', { error });
  removeSwipeSdk();
  setLocalStore(LocalStoreKeys.IS_SWIPE_SDK_INITIATED, false);
  return null;
};

export const fetchGameListData = async (
  swipeSDKConfig: LogiSDKConfig,
): Promise<SwipeGamesItem[]> => {
  if (swipeSDKConfig?.swipeGames?.gameListConfig?.remoteApiEnable) {
    try {
      const isDrawerMode = isTenantFeatureEnabled([TenantFeature.DRAWER_MENU]);
      const isV2Api = process.env.NX_GAME_LIST_API_VERSION === 'V2';

      if (!isV2Api && !isDrawerMode) {
        logger.info('Fetching game list using V1 API');
        return await fetchGameListV1(swipeSDKConfig);
      } else {
        logger.info('Fetching game list using V2 API');
        return await fetchGameListV2(swipeSDKConfig);
      }
    } catch (error) {
      return handleError(error) || [];
    }
  }

  try {
    logger.info('Using local game list configuration');
    return (
      swipeSDKConfig?.swipeGames?.gameListConfig?.gameList.map(
        (gameItem: SwipeGamesItem) => {
          assert(gameItem, SwipeGamesItemSchema);
          return gameItem;
        },
      ) || []
    );
  } catch (error) {
    return handleError(error) || [];
  }
};

export const filterPlayForFunGames = (
  playForFunMode: boolean,
  gameList: SwipeGamesItem[],
) => {
  return gameList.filter((game) => {
    if (playForFunMode && game.hasPff !== undefined) {
      return game.hasPff;
    }

    return true;
  });
};
